/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { Component } from 'react';
import flow from 'lodash/flow';
import {
	AnalyticsSubject,
	AnalyticsSource,
} from '@jira/platform__analytics-web-react/src/components/decorators.tsx';
import AppBase from '@jira/platform__utils-app-base/src/index.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import DwellTime from './view/index.tsx';

export type Props = {
	sessionId: string;
	data: {
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		attributes?: any;
		containerId?: string | null;
		objectId?: string | null;
		objectType?: string | null;
		actionSubject?: string | null;
		source?: string | null;
	};
};

type State = {
	DwellTimeComponent: ReturnType<typeof getDwellComponent>;
};

const defaultSource = 'dwellComponent';
const defaultActionSubject = 'dwellComponent';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const getDwellComponent = (source?: string | null, actionSubject?: string | null): any =>
	flow(
		AnalyticsSubject(actionSubject || defaultActionSubject),
		AnalyticsSource(source || defaultSource, SCREEN),
	)(DwellTime);

// eslint-disable-next-line jira/react/no-class-components
export default class DwellWrapper extends Component<Props, State> {
	static getDerivedStateFromProps(props: Props): {
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		DwellTimeComponent: any;
	} {
		const { data } = props;
		return {
			DwellTimeComponent: getDwellComponent(data.source, data.actionSubject),
		};
	}

	constructor(props: Props) {
		super(props);
		this.state = {
			DwellTimeComponent: null,
		};
	}

	render(): React.JSX.Element | null {
		const { sessionId, data } = this.props;
		const { DwellTimeComponent } = this.state;

		const enrichedData = {
			...data,
			source: (data && data.source) || defaultSource,
			actionSubject: (data && data.actionSubject) || defaultActionSubject,
		};

		if (sessionId && DwellTimeComponent) {
			return (
				<AppBase>
					<DwellTimeComponent sessionId={sessionId} data={enrichedData} />
				</AppBase>
			);
		}
		return null;
	}
}
